import {CustomerLogo} from './customer-logo.model';

export class CustomerModel {
  id?: number;
  active: boolean;
  companyLogo?: any;
  confirmed: boolean;
  customerName: string;
  customerNumber: string;
  customerCategory: string;
  countryCode: string;
  contactPersonFirstName: string;
  contactPersonLastName: string;
  logo: CustomerLogo;
  roles: Array<any>;

  constructor() {
    Object.assign(this);
  }
}
